import React, { Component } from "react";
import { View, Text, TouchableOpacity, Platform } from "react-native";
import styles from "../../styles/termsAndConditioStyles";
import { SERVER_ERROR, TermsConditions } from "../../constants/textConstants";
import Header from "../../commonComponents/Header";
import { decrypt } from "../../utils/encryption";
import apis from "../../services/api-services";
import HocComponent from "../../commonComponents/Hoc";
const paragraphs = [
  TermsConditions.para1,
  TermsConditions.para2,
  TermsConditions.para3,
];
class TermsAndConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerId: "",
      redirect: "",
    };
  }

  async componentDidMount() {
    let urlData;
    if (Platform.OS === "web") {
      let encrypteddata = window.location.search.replace("?data=", "");
      if (encrypteddata != "") {
        urlData = JSON.parse(decrypt(encrypteddata));
        this.setState({
          customerId: urlData.Id,
          redirect: urlData.No ? process.env.WHATSAPP_LINK + urlData.No : false,
        });
      }
    } else {
      // get encrypted data
    }
  }

  //submit terms & condition
  submitTermsCodition = (value) => {
    apis.term
      .termsAndCondition({
        customerId: this.props.customerId
          ? this.props.customerId
          : this.state.customerId,
        status: value,
      })
      .catch(() => alert(SERVER_ERROR));
    if (this.props.customerId) {
      this.props.hideTerms();
    } else if (this.state.redirect) {
      window.open(this.state.redirect, "_self");
    }
  };

  render() {
    const termsContainer = `termsContainer_${this.props.measure}`;

    return (
      <View>
        <Header
          showHeader={true}
          headerText="Terms and Conditions"
          popupClose={true}
          submitTermsCodition={() => this.submitTermsCodition("Close")}
        />
        <View style={styles.outerContainer}>
          <View style={[styles.container, styles[termsContainer]]}>
            <Text style={styles.headingText}>{TermsConditions.heading}</Text>
            {paragraphs.map((data, index) => {
              return (
                <View
                  key={`paragraphs${index}`}
                  nativeID={`paragraphs${index}`}
                  style={{ flexDirection: "row" }}
                >
                  <Text style={styles.number}>{`1.${index + 1}.`}</Text>
                  <Text style={styles.paragraph}>{data}</Text>
                </View>
              );
            })}

            <View style={styles.buttonView}>
              <TouchableOpacity
                style={styles.button}
                onPress={() => {
                  this.submitTermsCodition("Accept");
                }}
              >
                <Text style={styles.buttonText}>Accept</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  this.submitTermsCodition("Reject");
                }}
                style={styles.button}
              >
                <Text style={styles.buttonText}>Reject</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
    );
  }
}

export default HocComponent(TermsAndConditions);
